<template>
  <div class="app-container">
    <el-container v-if="isLoggedIn">
      <el-aside :width="sidebarWidth">
        <app-sidebar ref="sidebarRef" />
      </el-aside>
      <el-container>
        <el-header height="60px">
          <app-header />
        </el-header>
        <el-main>
          <router-view />
        </el-main>
        <el-footer height="40px">
          <app-footer />
        </el-footer>
      </el-container>
    </el-container>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { computed, ref, provide, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import AppHeader from './components/layout/AppHeader.vue'
import AppSidebar from './components/layout/AppSidebar.vue'
import AppFooter from './components/layout/AppFooter.vue'
import { applyResizeObserverPatch } from './utils/resize-observer-patch'

// 侧边栏参考和状态
const sidebarRef = ref(null)
const sidebarCollapsed = ref(false)

// 侧边栏宽度
const sidebarWidth = computed(() => {
  return sidebarCollapsed.value ? '64px' : '220px'
})

// 提供更新状态的方法给子组件
const updateSidebarCollapsed = (value) => {
  sidebarCollapsed.value = value
}

// 使用provide共享状态更新方法
provide('updateSidebarCollapsed', updateSidebarCollapsed)

// 计算是否已登录 (简单通过路由判断，实际项目中应该使用状态管理)
const route = useRoute()
const isLoggedIn = computed(() => route.path !== '/login')

// 应用ResizeObserver补丁
onMounted(() => {
  applyResizeObserverPatch()
})
</script>

<style>
/* 全局样式 */
:root {
  --primary-color: #1e5cb3;
  --primary-light: #3a78d4;
  --secondary-color: #4a8fe7;
  --accent-color: #17a2b8;
  --dark-color: #343a40;
  --light-color: #f8f9fa;
  --gradient-primary: linear-gradient(135deg, var(--primary-color), var(--secondary-color));
  --text-primary: #2c3e50;
  --text-secondary: #34495e;
  --border-radius: 10px;
  --box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
  color: var(--text-primary);
  background-color: #f5f7fa;
  letter-spacing: 0.01em;
  line-height: 1.6;
}

/* 布局样式 */
.app-container {
  min-height: 100vh;
}

.el-container {
  height: 100vh;
}

.el-aside {
  background-color: #304156;
  color: #fff;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  transition: width 0.3s ease;
}

.el-header {
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  padding: 0 20px;
}

.el-main {
  padding: 20px;
  background-color: #f5f7fa;
  overflow-y: auto;
}

.el-footer {
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}
</style> 